<script setup lang="ts">
import { Check, CheckSquare2, X } from 'lucide-vue-next'
import { httpsCallable } from 'firebase/functions'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { firebaseClient } from '@/firebase'
import { useWorkflowStore } from '@/stores/domain'

const store = useWorkflowStore()
const { approvals } = storeToRefs(store)
const resolving = ref<string>()
const decide = async (approvalId: string, approved: boolean) => {
  resolving.value = approvalId
  try {
    const approval = approvals.value.find((item) => item.id === approvalId)
    const callable = approval?.kind === 'browser_submit' ? 'resolveBrowserApproval' : 'resolveWorkflowApproval'
    await httpsCallable(firebaseClient.functions, callable)({ approvalId, approved })
  } finally { resolving.value = undefined }
}
</script>

<template>
  <div class="section-page">
    <header class="section-page__header"><div><span class="eyebrow">Human control</span><h1>Approvals</h1><p>High-impact workflow steps remain paused and consume no execution slot until you decide.</p></div></header>
    <section class="detail-card detail-card--wide"><div class="detail-card__head"><div><span class="eyebrow">Pending</span><h2>Decisions</h2></div><CheckSquare2 :size="18" /></div>
      <div v-if="approvals.filter((item) => item.status === 'pending').length" class="team-list"><div v-for="approval in approvals.filter((item) => item.status === 'pending')" :key="approval.id"><i class="specialist-avatar specialist-avatar--purple"><CheckSquare2 :size="14" /></i><span><strong>{{ approval.title }}</strong><small>{{ approval.detail }}</small></span><button type="button" class="icon-button" :disabled="resolving === approval.id" aria-label="Approve" @click="decide(approval.id, true)"><Check :size="16" /></button><button type="button" class="icon-button" :disabled="resolving === approval.id" aria-label="Reject" @click="decide(approval.id, false)"><X :size="16" /></button></div></div><p v-else>No decisions are waiting.</p>
    </section>
  </div>
</template>
